// extracted by mini-css-extract-plugin
module.exports = {"Centered":"Spinner_Centered__1mKoJ","Spinner":"Spinner_Spinner__1sm_k"};